import React from 'react'
import PoiMarker from './PoiMarker'
import { selectGeoentityMarkers } from '../../../store/geoentity/geoentity.selectors'
import { useSelector } from 'react-redux'
import { withMapReady } from '../map.utils'
import { focusGeoentity, requestUnfocusGeoentity } from '../../../store/geoentity/geoentity.actions'
import { navigateToGeoentity } from '../../../store/history/history.actions'
import { useAction } from '../../utils/react-redux'
import { dispatchTag } from '../../../store/analytics/analytics.actions'

import { TAG_CLICK_POI } from '../../../store/analytics/analytics.actionTypes'

// webpack:BrowserOnly
const PoisMarkers = (props = {}) => {
  const { shouldNavigateToPoiOnTap, selectMarkers = selectGeoentityMarkers } = props
  const markers = useSelector(selectMarkers)
  const dispatchTagAction = useAction(dispatchTag)
  const navigateToGeoentityAction = useAction(navigateToGeoentity)
  const dispatchFocusGeoentity = useAction(focusGeoentity)
  const dispatchRequestUnfocusGeoentity = useAction(requestUnfocusGeoentity)

  const navigateToPoi = ({ id, additionalInfo, rubricId }) => {
    dispatchTagAction({
      type: TAG_CLICK_POI,
      tagInfo: {
        affichage: 'carte',
        appId: additionalInfo?.appId,
        catId: rubricId
      }
    })
    navigateToGeoentityAction({ id, scrollTop: true })
  }

  return (
    <>
      {(markers || []).map(marker => {
        return (
          <PoiMarker
            key={marker.id}
            shouldNavigateToPoiOnTap={shouldNavigateToPoiOnTap}
            navigateToPoi={navigateToPoi}
            focusPoi={dispatchFocusGeoentity}
            unfocusPoi={dispatchRequestUnfocusGeoentity}
            {...marker}
          />
        )
      })}
    </>
  )
}

export default withMapReady(PoisMarkers)
